import { render, staticRenderFns } from "./orderConfirm_pc.vue?vue&type=template&id=f09c7a7a"
import script from "./orderConfirm_pc.vue?vue&type=script&lang=js"
export * from "./orderConfirm_pc.vue?vue&type=script&lang=js"
import style0 from "./orderConfirm_pc.vue?vue&type=style&index=0&id=f09c7a7a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports